import React from "react";
import Box from "@mui/material/Box";
import Step from "@mui/material/Step";
import Button from "@mui/material/Button";
import { DCStepper } from "../../assets/theme/theme";
import { Grid, StepLabel, Alert } from "@mui/material";
import ProfileInfoForm from "./ProfileInfoForm";
import { useUserProfileContext } from "../../contexts/UserProfileContext";
import { useHistory } from "react-router-dom";
import { IUser } from "../../firebaseTypes";
import { LoadingButton } from "@mui/lab";
import { useDocumentContext } from "../../contexts/DocumentContext";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useWalkThroughModalContext } from "../../contexts/WalkThroughModalContext";

const steps = [
  "Complete your Profile",
];

export interface Props {}

const OnboardingSteps: React.FC<Props> = () => {
  const [isSavingUser, setIsSavingUser] = React.useState(false);
  const {
    documents,
    initializedDocumentsAndFolders: initalizedDocumentsAndFolders,
  } = useDocumentContext();
  const { error, createUserProfile, userProfile } = useUserProfileContext();
  const history = useHistory();
  const transitionContainerRef = React.useRef(null);
  const { openWalkThroughModal } = useWalkThroughModalContext();
  const { setAccountDeleteConfirmationModalOpen } = useUserProfileContext();

  const validateProfileForm = React.useCallback((): boolean => {
    return (
      !!userProfile?.firstName &&
      !!userProfile.lastName &&
      !!userProfile.email &&
      !!userProfile.zipCode &&
      !!userProfile.country &&
      !!userProfile.state &&
      !!userProfile.nationality
    );
  }, [userProfile]);

  const gotoDashboard = React.useCallback(async () => {
    setIsSavingUser(true);
    const success = await createUserProfile(userProfile as IUser);
    setIsSavingUser(false);
    if (success) {
      if (initalizedDocumentsAndFolders && documents.length === 0) {
        console.log(`redirecting to /documents`);
        history.push("/documents");
        openWalkThroughModal(1000);
      } else {
        history.push("/");
      }
    }
  }, [
    createUserProfile,
    userProfile,
    initalizedDocumentsAndFolders,
    documents.length,
    history,
    openWalkThroughModal,
  ]);

  return (
    <Box sx={{ width: '100%' }} className="profile-blog">
      <DCStepper activeStep={0}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </DCStepper>

      {error && (
        <Box mt={4} mb={2}>
          <Alert variant="outlined" severity="error">
            {error}
          </Alert>
        </Box>
      )}

      <Box mt={6}>
        <Box className="use-profile">
          <>
            <Box
              id="profile-setup-0"
              ref={transitionContainerRef}
            >
              <ProfileInfoForm />
            </Box>
            <Box mt={5} flex="1" display="flex">
              <Grid container spacing={2} justifyContent="center">
                <Grid item>
                  <LoadingButton
                    loadingPosition="center"
                    loading={isSavingUser}
                    aria-label="goto dashboard"
                    variant="contained"
                    color="primary"
                    disableElevation
                    disabled={!validateProfileForm()}
                    onClick={gotoDashboard}
                    endIcon={
                      initalizedDocumentsAndFolders &&
                        documents.length === 0 ? (
                        <ArrowForwardIcon />
                      ) : null
                    }
                  >
                    {/* {initalizedDocumentsAndFolders && documents.length === 0 ? 'Ready to Upload' : 'Save'} */}
                    Save
                    {/* todo: disable goto dash until atleast one pic is uploaded */}
                    {/* todo: goto dashboard should take user to the dashboard */}
                  </LoadingButton>
                </Grid>
                <Grid item>
                  <Button
                    className="goto-dashboard-btn"
                    variant="outlined"
                    // variant="text"
                    color="primary"
                    onClick={gotoDashboard}
                    disableElevation
                  >
                    Go to dashboard
                    {/* todo: disable goto dash until at-least one pic is uploaded */}
                    {/* todo: goto dashboard should take user to the dashboard */}
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    className="goto-dashboard-btn"
                    variant="contained"
                    // variant="text"
                    color="error"
                    onClick={() => setAccountDeleteConfirmationModalOpen(true)}
                    disableElevation
                  >
                    Delete Account
                    {/* todo: disable goto dash until at-least one pic is uploaded */}
                    {/* todo: goto dashboard should take user to the dashboard */}
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </>
        </Box>
      </Box>
    </Box>
  );
};

export default OnboardingSteps;
